/**
 * Layout breakpoints shared by CSS and JS.
 *
 * CSS custom properties can't be used inside @media, so *.module.css files repeat these
 * numbers literally — keep them in sync:
 *   mobile → @media (max-width: 767px)
 *   split  → @media (min-width: 1024px)
 *   auth   → @media (min-width: 1081px): the auth pages' onboarding panel + form columns,
 *            Flutter's `screenSize.width > 1080` (web_login_page.dart, web_signup_page.dart)
 *
 * mobile is the counterpart of Flutter ResponsiveUI.isMobile (responsive_ui.dart). Flutter
 * switches at 450px (app.dart ResponsiveBreakpoints); the React app uses 768px so phones in
 * landscape and small tablets get the mobile layout too.
 */

/** Widest viewport that still gets the mobile layout. */
export const MOBILE_MAX_WIDTH = 767;

/** Narrowest viewport with the desktop list/detail split (Home, Jobs, My Jobs). */
export const SPLIT_MIN_WIDTH = 1024;

export const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
export const SPLIT_QUERY = `(min-width: ${SPLIT_MIN_WIDTH}px)`;
